import { Modal } from 'antd';
import '../../style/advancedUI/modal/modal.less';

export default Modal;